import {
  Menu,
  MenuItem,
  styled,
  Typography,
} from "@mui/material";

export const StyledMenu = styled(Menu)(({ colors }: { colors: any }) => ({
  "& .MuiMenu-paper": {
    backgroundColor: colors?.background?.popover,

    borderRadius: "0.5rem",
    boxShadow:
      "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
    padding: "0.5rem 0",
    // marginTop: "0.7%",
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ colors }: { colors: any }) => ({
  padding: "0.5rem 0.75rem",
  fontSize: "1rem",
  fontWeight: 400,
  lineHeight: "1.5rem",
  fontFamily: "Roboto",
  minWidth: "7rem",
  color: colors?.text?.label,

  "&:hover": {
    backgroundColor: colors?.hover?.muted,
  },
  "&.Mui-selected": {
    backgroundColor: colors?.primary?.selected,
  },
  "&.Mui-selected:hover": {
    backgroundColor: colors?.hover?.muted,
  },
}));
